const link = {
	attrs: {
		href: {},
		resourcePath: {},
		hash: { default: "" },
		isFile: { default: false },
	},
	inclusive: false,
};

export default link;
